import { useTags } from "../../../../common/composables/useTags";
import { StoreProps } from "../../../../store/useDataStore";
import { PriceAdjustmentProps } from "../interfaces/PriceAdjustmentProps";

const PriceAdjustmentDefaults: Partial<PriceAdjustmentProps> = {
  captchaSiteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
  enableCaptcha: false,
  pageName: useTags('getTag', 'PRICE_ADJUST'),
  homePageValues: {
    couponRelated: '',
    lowerPriceItem: '',
    orderDate: '',
    otherType: '',
    otherValue: '',
    show14DaysErrorPage: false,
    reiCom: '',
  },
};

export const createFallbackStore = (customDefaults?: Partial<PriceAdjustmentProps>): StoreProps<PriceAdjustmentProps> => {
  const combinedDefaults = { ...PriceAdjustmentDefaults, ...customDefaults } as PriceAdjustmentProps;

  return {
    globalState: combinedDefaults,
    getValues: (keys) => {
      const values = {} as Pick<PriceAdjustmentProps, typeof keys[number]>;
      keys.forEach(key => {
        values[key] = combinedDefaults[key] as PriceAdjustmentProps[typeof key];
      });
      return values;
    },
    setValues: (payload) => {
      return { ...combinedDefaults, ...payload } as PriceAdjustmentProps;
    },
  };
};

Object.freeze(PriceAdjustmentDefaults);
export default PriceAdjustmentDefaults;
